class CollectionSlider extends HTMLElement {
  constructor() {
    super();

    let options = {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      groupCells: 4
    };

    if (matchMedia("(max-width: 767px)").matches) {
      options.groupCells = null;
      options.dragThreshold = 10;
      options.freeScroll = true;
      options.cellAlign = "left";
    }

    const slider = new Flickity(this.querySelector(".collection-slider"), options);

    this.querySelector(".slider-button-next").addEventListener("click", () => {
      slider.next();
    });

    this.querySelector(".slider-button-previous").addEventListener("click", () => {
      slider.previous();
    });
  }
}

customElements.define("collection-slider", CollectionSlider);
